import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import { RenderPropWithProps } from '../../../../common/types/prop-types/common';
import { AppThunkDispatch } from '../../../../prime/common/types';
import * as CommonErrorBoundaryService from '../../../services/error-boundary';
import { ErrorBoundaryError, ErrorBoundaryState } from '../../../services/error-boundary/Types';

export interface ErrorBoundaryProps {
    config: any;
    error: ErrorBoundaryError;
    hasError: boolean;
}

export interface ErrorBoundaryContainerProps {
    config: any;
}

interface ReduxStateProps {
    errorState: ErrorBoundaryState;
    hasError: boolean;
}

interface ReduxDispatchProps {
    errorBoundaryServiceActions: CommonErrorBoundaryService.Service.ServiceActions;
}

class ErrorBoundaryContainer extends Component<
    ErrorBoundaryContainerProps &
    RenderPropWithProps<ErrorBoundaryProps> &
    ReduxStateProps & ReduxDispatchProps
> {
    public static propTypes = {
        config: PropTypes.object.isRequired,
        errorState: PropTypes.any,
        hasError: PropTypes.bool.isRequired,
        errorBoundaryServiceActions: PropTypes.any,
        //
        children: PropTypes.func.isRequired,
    };

    public componentDidCatch(error: Error | null, info: object) {
        this.props.errorBoundaryServiceActions.handleError(error || new Error(), info);
    }

    public render() {
        const { message, stack, info, showGeneric } = this.props.errorState.data;
        const newProps: ErrorBoundaryProps = {
            config: this.props.config,
            error: { message, stack, info, showGeneric } as ErrorBoundaryError,
            hasError: this.props.hasError,
        };
        return this.props.children(newProps);
    }
}

const mapStateToProps = (store: { errorBoundaryState: ErrorBoundaryState}) => ({
    errorState: store.errorBoundaryState,
    hasError: store.errorBoundaryState.data.message !== null,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch, ownProps: ErrorBoundaryContainerProps) => ({
    errorBoundaryServiceActions: CommonErrorBoundaryService.Service.bindServiceActionCreators(ownProps.config, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundaryContainer);
